<header>
  <div></div>
  <nav>
    <!-- Native iOS/Android app: show regular buttons -->
    <ng-container *ngIf="isMobilePlatform; else webVersion">
      <button class="try-button" (click)="onTryForFreeClicked()">Join</button>
      <button class="sign-in-button" (click)="onSignInClicked()">Sign in</button>
    </ng-container>
    <!-- Web version: show platform-specific buttons -->
    <ng-template #webVersion>
      <ng-container *ngIf="detectedMobileDevice === 'ios'; else notIos">
        <a href="https://apps.apple.com/us/app/3dway/id6448911494" target="_blank" rel="noopener noreferrer" class="try-button">Open App</a>
      </ng-container>
      <ng-template #notIos>
        <ng-container *ngIf="detectedMobileDevice === 'android'; else desktopButtons">
          <button class="try-button" (click)="onSignInClicked()">Join on Desktop</button>
        </ng-container>
      </ng-template>
      <ng-template #desktopButtons>
        <button class="try-button" (click)="onTryForFreeClicked()">Join</button>
        <button class="sign-in-button" (click)="onSignInClicked()">Sign in</button>
      </ng-template>
    </ng-template>
  </nav>
</header>
<div class="landing-container">
  <main>
    <div class="background-light"></div>
    <div class="text-content">
      <h1 class="text1">
        Your 3D Portfolio is Unique.
      </h1>
      <h1 class="text2">Share It with the Whole World.</h1>
      <h1 class="text3">
        One-click upload Portfolio.
        <h2 class="text4">Forget about Storage Limits. It's Unlimited.</h2>
      </h1>
    </div>
    <div class="image-container">
      <div class="desktop-view">
        <img class="monitor-frame" src="assets/images/new-landing/device-imac.svg" alt="monitor frame"/>
        <!-- FIRST SCREEN DESKTOP-->
        <img class="monitor-video video1" src="assets/images/new-landing/ScreenRecord1_compressed_cropped.jpg" alt="preview" *ngIf="!isFirstDesktopVideoReady">
        <video class="monitor-video video1" loop muted playsinline (canplaythrough)="desktopVideoReady($event)" preload="auto" >
          <source [src]="getMediaUrl('/_landing/ScreenRecord1_compressed_cropped.mp4', true)" type="video/mp4">
        </video>
        <img class="monitor-group" src="assets/images/new-landing/drag_n_drop_desktop.jpg" alt="monitor group">
        <video class="monitor-video video2" loop muted playsinline (canplaythrough)="playVideo($event)">
          <source [src]="getMediaUrl('/_landing/Drag&Drop_step1_2MB.mp4', true)" type="video/mp4">
        </video>
      </div>
      <!-- First screen: Video phone -->
      <div class="phone-container phone-composition">
        <img class="phone-frame" src="assets/images/new-landing/device-phone.svg" alt="Phone">
        <!-- FIRST SCREEN MOBILE -->
        <img class="phone-media first-screen-phone-video" src="assets/images/new-landing/first_screen_resized.jpg" alt="preview" *ngIf="!isFirstMobileVideoReady">
        <video class="phone-media first-screen-phone-video" loop muted playsinline webkit-playsinline (canplaythrough)="mobileVideoReady($event)" preload="auto" >
          <source [src]="getMediaUrl('/_landing/first_screen_resized.mp4')" type="video/mp4">
        </video>
        <img class="phone-media second-screen-phone-image" src="assets/images/new-landing/drag_n_drop_mobile.png" alt="Collection">
        <video class="phone-media third-screen-phone-video" loop muted playsinline webkit-playsinline (canplaythrough)="playVideo($event)">
          <source [src]="getMediaUrl('/_landing/mobile_drag_drop.mp4')" type="video/mp4">
        </video>
      </div>
    </div>
    <div class="background-videos">
      <video class="bg-img-1" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/5_web_hevc_resized.mp4')" alt="background image 1"></video>
      <video class="bg-img-2" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/3_mob_hevc_resized.mp4')" alt="background image 2"></video>
      <video class="bg-img-3" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/1_mob_hevc_resized.mp4')" alt="background image 3"></video>
      <video class="bg-img-5" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/4_web_hevc_resized.mp4')" alt="background image 5"></video>
      <video class="bg-img-6" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/6_mob_hevc_resized.mp4')" alt="background image 6"></video>
      <video class="bg-img-7" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/3_web_hevc_resized.mp4')" alt="background image 7"></video>
      <video class="bg-img-4" muted loop playsinline autoplay (canplaythrough)="playVideo($event)" [src]="getMediaUrl('/_landing/2_mob_hevc_resized.mp4')" alt="background image 4"></video>

    </div>
  </main>
</div>
<app-scroll-cue
  [sections]="3"
  scrollTargetId="landing2025-pricing"
  switchTargetId="landing2025-pricing"
  ariaLabel="Scroll to pricing section">
</app-scroll-cue>

<section class="our-pricing-section" id="landing2025-pricing">
  <h2 class="price-section-title">Share 3D as You Intended.</h2>
  <div class="features-grid">
    <div class="feature-card">
      <div class="card-content">
        <!-- <div class="divider"></div> -->
        <h3>3DWay Artist Program
          <span class="price-tag">$65/year</span>
        </h3>

        <p class="membership-content">Membership lets you upload models, share device‑fit renders and analyze what resonates.</p>
        <div class="devices">
          <div class="macbook-container">
            <img class="macbook-frame" src="assets/images/new-landing/device-macbook.svg" alt="Macbook">
            <video class="macbook-video" autoplay loop muted playsinline (canplaythrough)="playVideo($event)">
              <source [src]="getMediaUrl('/_landing/pricing_part_model_video_web.mp4')" type="video/mp4">
            </video>
            <div class="phone-container">
              <img class="phone-frame" src="assets/images/new-landing/device-phone.svg" alt="Phone">
              <video class="phone-video" autoplay loop muted playsinline (canplaythrough)="playVideo($event)">
                <source [src]="getMediaUrl('/_landing/pricing_part_model_video_app.mp4')" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
        <div class="card-cta-section">
          <button class="try-button-black" (click)="onTryForFreeClicked()">Join</button>
          <p>We will cancel and refund your membership<br> at any time if you are dissatisfied.</p>
        </div>
      </div>
    </div>
    <!-- <div class="feature-card">
      <div class="card-content">
        <div class="divider"></div>
        <h3>Pay-as-you-go</h3>
        <p>$9.99 per month for storage. $4.99 per upload. <br><br> Think in terms of models and scenes, not gigabytes or rendering time.</p>
        <div class="card-cta-section">
          <button class="try-button-black" (click)="onTryForFreeClicked()">Join</button>
          <p>No credit card required</p>
        </div>
      </div>
    </div>
    <div class="feature-card">
      <div class="card-content">
        <div class="divider"></div>
        <h3>Billing Protection</h3>
        <p>Stay in control of your spending with upload limits. Set alerts per billing cycle.</p>
        <app-renderlimit-select [tooltipEnabled]="true"></app-renderlimit-select>
      </div>
    </div> -->
  </div>
  <div class="cta-section">
    <span>By continuing you agree to our <span class="link-span"><a routerLink="/legal/terms-of-service">Terms of Service</a> and <a routerLink="/legal/privacy-policy">Privacy Policy.</a></span></span>
  </div>
</section>

<!-- Mobile Splash Screen - only shown in mobile builds -->
<app-splash-screen
  *ngIf="isMobilePlatform && (isMobileSplashVisible$ | async)"
  [showSignInForm]="(mobileSplashConfig$ | async)?.showSignInForm || false"
  [progressBarValue]="0"
  (closeClicked)="authModalService.onSplashCloseClicked()"
  (signInAppleClicked)="authModalService.onSplashSignInAppleClicked()"
  (signInGoogleClicked)="authModalService.onSplashSignInGoogleClicked()"
  [@fullscreenPanelAnimation]>
</app-splash-screen>
